
<template>
  <!--限时秒杀 limitedTimeDiscount-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="id"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_img" slot-scope="{row}">
        <img style="height: 44px;width:auto" :src="row.imgUrl" alt="">
      </template>

      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="activityColor[row.status]"></span>
          <span>{{ row.statusDesc }}</span>
        </div>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
const activityType = [
  { value: 1, label: '活动 ' },
  { value: 2, label: '团购' }
];
export default {
  name: 'localLimitedTimeSeckill',
  mixins: [fetchSelect],
  data () {
    return {
      activityColor: [
        'info-bg',
        'success-bg',
        'info-bg',
        'info-bg',
        'info-bg'
      ],
      searchList: [
        { props: ['title'], placeholder: '标题', options: [], inputType: 'input' },
        { props: ['activityTime'], placeholder: '活动时间', options: [], inputType: 'datePick' },
        { props: ['shopName'], placeholder: '店铺', options: [], inputType: 'input' },
        {
          props: ['isNewMember'],
          placeholder: '新客专享',
          options: [
            {label: '是', value: 1},
            {label: '否', value: 0}
          ],
          inputType: 'select'
        },
        {
          props: ['status'],
          placeholder: '活动状态',
          options: [
            // {label: '未开始', value: 0},
            // {label: '进行中', value: 1},
            // {label: '已暂停', value: 2},
            // {label: '已结束', value: 3}
          ],
          inputType: 'select'
        }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '详情', handle: (row) => this.toDetail(row.seckillId), permi: ['community:localSecKill:query'] },
        { text: '查看订单', handle: (row) => this.toapplylist(row.seckillId), permi: ['community:localOrder:list']}
      ],
      columns: [
        { title: '活动ID', dataIndex: 'seckillId', align: '', width: '' },
        { title: '封面图', dataIndex: 'imgUrl', align: '', width: '', scopedSlots: { customRender: 'img' } },
        { title: '标题', dataIndex: 'title', align: '', width: '' },
        { title: '店铺', dataIndex: 'shopName', align: '', width: '' },
        { title: '活动日期', dataIndex: 'activityDateDesc', align: '', width: '' },
        { title: '每日份数', dataIndex: 'dailyCopies', align: '', width: '' },
        { title: '秒杀价格', dataIndex: 'seckillFee', align: '', width: '', customCell: (row) => ({ domProps: { innerHTML: '￥' + row.seckillFee} })},

        { title: '新客专享', dataIndex: 'isNewMemberDesc', align: '', width: '' },
        { title: '活动状态', dataIndex: 'statusDesc', align: '', width: '', scopedSlots: { customRender: 'status' } },
        { title: '操作', dataIndex: 'action', align: '', width: '', scopedSlots: { customRender: 'action' } }
      ],
      dataSource: [],
      searchParams: {
        title: undefined,
        activityTime: undefined,
        shopName: undefined,
        isNewMember: undefined,
        status: undefined
      },
      listApi: {
        url: '/local/shop/seckill/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addActivity',
        addTitle: '新建活动',
        editTitle: '编辑活动'
      },
      deleteParam: {
        url: '',
        title: '',
        key: '',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      let paramArr = [
        {index: 4, scope: 'searchList', query: 'comu_local_seckill_status'}
      ];
      this.dictionarySelect(paramArr);
    },
    toapplylist (seckillId) {
      this.$router.push({
        name: 'goodsOrder',
        query: { seckillId, ...this.breadParam(this) }
      });
    },
    // 详情
    toDetail (id) {
      this.$router.push({
        name: 'localLimitedTimeSeckillDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    /** 查看订单 */
    showOrder (row) {
      this.$router.push({
        name: 'activityOrder',
        query: { id: row.id, activityTitle: row.title, time: row.activityTime }
      });
    },
    /** 切换状态 */
    changeStatus (row) {
      this.$put({
        url: `/pm/lottery/changeStatus/${row.id}`,
        params: { status: row.status === 1 ? 0 : 1 } // 0停用，1启用
      }).then(({ data }) => {
        this.$message.success('切换成功');
        this.$refs.table.getTableList();
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<!-- <style scoped>
  ::v-deep layout-content{
    padding:0;
    background: white ;
  }
</style>
<style>
  ::v-deep .layout-content{
    padding:0;
    background: white ;
  } -->
</style>
